import axios from '../axios'

// モジュール項目の削除
const deleteModuleItemApi = async (itemId) => {
  return await axios.delete(`api/lms/module-items/${itemId}`)
}

export default deleteModuleItemApi
